const BASE_PATTERN = /^https:\/\/.+\/$/;
const SLUG_PATTERN = /^[a-z0-9-]+$/;

export function isValidWidgetConfig(base: string, slug: string): boolean {
  return BASE_PATTERN.test(base ?? '') && SLUG_PATTERN.test(slug ?? '');
}

/**
 * Builds the ARENA iframe URL `{base}{slug}?key={token}`.
 * Pure: returns null (never throws) for an invalid configuration or an empty token.
 */
export function buildArenaWidgetUrl(base: string, slug: string, token: string): string | null {
  return isValidWidgetConfig(base, slug) && token ? `${base}${slug}?key=${encodeURIComponent(token)}` : null;
}
